import { render, staticRenderFns } from "./MobilePlanTable.vue?vue&type=template&id=607d83f3"
import script from "./MobilePlanTable.vue?vue&type=script&lang=js"
export * from "./MobilePlanTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports